import { render, staticRenderFns } from "./RealTimePopularity.vue?vue&type=template&id=3821fab0&scoped=true"
import script from "./RealTimePopularity.vue?vue&type=script&lang=ts"
export * from "./RealTimePopularity.vue?vue&type=script&lang=ts"
import style0 from "./RealTimePopularity.vue?vue&type=style&index=0&id=3821fab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821fab0",
  null
  
)

export default component.exports